import React, { useState } from 'react';
import '../IMRPage/IMRPage.css';
import martinLogo from '../../assets/Martin-red.png';
import useSeo from '../../helpers/useSeo';

import asset1 from '../../assets/25_Fairbanks Chevy GMC_012_Emailer.jpg';
import asset2 from '../../assets/26 Jim Hardman_003_800w Email_March.jpg';
import asset3 from '../../assets/26 Taylor Motors_002_800w Email_Love.jpg';
import wakefieldDirectMail from '../../assets/WakefieldGMC-DirectMailExample.png';
import directMailCheck from '../../assets/ClientDirectMail-CheckMailer.png';
import directMailEquity from '../../assets/ClientDirectMail-EquityMailer.png';

const IMR_EMAIL_ENDPOINT = process.env.REACT_APP_EMAILER_ENDPOINT || 'https://emailer.martinadvertising.com/';

const CONQUEST_OPTIONS = [
  {
    id: 'full-market-coverage',
    label: 'Full Market Coverage – Impressions and Inventory Subject to Market Availability'
  },
  {
    id: '10000',
    label: '$10,000 - 200,000 Emails (2 Drops) + 100,000 Social Retargeting Impressions + Sales Matches'
  },
  {
    id: '7500',
    label: '$7,500 - 150,000 Emails (2 Drops) + 75,000 Social Retargeting Impressions + Sales Matches'
  },
  {
    id: '5000',
    label: '$5,000 - 100,000 Emails (2 Drops) + 50,000 Social Retargeting Impressions + Sales Matches'
  }
];

const DIRECT_MAIL_OPTIONS = [
  {
    id: 'full-market-coverage',
    label: 'Full Market Coverage – Impressions and Inventory Subject to Market Availability'
  },
  {
    id: '10000',
    label: '$10,000 – 8,500 Pieces + Social Media Retargeting + Geographic Performance Heatmap + Data Purchase'
  },
  {
    id: '7500',
    label: '$7,500 – 6,000 Pieces + Social Media Retargeting + Geographic Performance Heatmap + Data Purchase'
  },
  {
    id: '5000',
    label: '$5,000 – 4,500 Pieces + Social Media Retargeting + Geographic Performance Heatmap + Data Purchase'
  }
];

const OTT_OPTIONS = [
  {
    id: 'full-market-coverage',
    label: 'Full Market Coverage – Impressions and Inventory Subject to Market Availability'
  },
  {
    id: '15000',
    label: '$15,000 – 330,000 Impressions in In-Game Live Sports (NBA Playoffs / MLB / Stanley Cup Playoffs / PGA Tour / NASCAR)'
  },
  {
    id: '10000',
    label: '$10,000 – 220,000 Impressions in In-Game Live Sports (NBA Playoffs / MLB / Stanley Cup Playoffs / PGA Tour / NASCAR)'
  },
  {
    id: '7500',
    label: '$7,500 – 150,000 Impressions in In-Game Live Sports (NBA Playoffs / MLB / Stanley Cup Playoffs / PGA Tour / NASCAR)'
  }
];

const PRODUCTION_SHOOT_OPTIONS = [
  {
    id: '25000',
    label: '$25,000 – Two-Day Shoot on-site + Two :30 Second TV Spots + Testimonials + Full Access to Footage'
  },
  {
    id: '15000',
    label: '$15,000 – One-Day Shoot on-site + One :30 Second TV Spot + Testimonials + Full Access to Footage'
  }
];

const TV_RADIO_OPTIONS = [
  {
    id: '1800',
    label: '$1,800 – :30 Second iMR Approved TV Spot + Offer Tag with Dealership Offer + iMR Filing'
  },
  {
    id: '1500',
    label: '$1,500 – :15 Second iMR Approved TV Spot + Offer Tag with Dealership Offer + iMR Filing'
  },
  {
    id: '800',
    label: '$800 – :30 Second iMR Approved Radio Spot + Offer Tag with Dealership Offer + iMR Filing'
  }
];

// Assets keyed by section
const SECTION_ASSETS = {
  conquest: [
    { src: asset1, label: 'Fairbanks Chevy GMC — Emailer', type: 'image' },
    { src: asset2, label: 'Jim Hardman — Email (March)', type: 'image' },
    { src: asset3, label: 'Taylor Motors — Email (Love)', type: 'image' },
  ],
  directMail: [
    { src: directMailEquity, label: 'Equity Mailer', type: 'image' },
    { src: directMailCheck, label: 'Check Mailer', type: 'image' },
    { src: wakefieldDirectMail, label: 'Wakefield GMC — Direct Mail', type: 'image' },
  ],
  shoot: [
    { src: 'https://pub-a6410c3681b541449845fc3f20fbc373.r2.dev/DealershipSpotExample-MartinAdvertising.mp4', label: 'David Scott Lee — Dealership Spot', type: 'video' },
    { src: 'https://pub-a6410c3681b541449845fc3f20fbc373.r2.dev/HardmanMarch-MarchMadnessTrucksJHM009G26H.mp4', label: 'Hardman — March Madness Trucks', type: 'video' },
  ],
  tvSpot: [
    { src: 'https://pub-a6410c3681b541449845fc3f20fbc373.r2.dev/HowardBentleyTVSpot.mp4', label: 'Howard Bentley Buick GMC – Evergreen', type: 'video' },
    { src: 'https://pub-a6410c3681b541449845fc3f20fbc373.r2.dev/SapaughTVSpot.mp4', label: 'Sapaugh Cadillac – Monthly Offers', type: 'video' },
    { src: 'https://pub-a6410c3681b541449845fc3f20fbc373.r2.dev/MotorCityBizEliteJulyGJGW6615002H.mp4', label: 'Motor City Buick GMC – Business Elite', type: 'video' },
  ],
  ott: [
    { src: 'https://pub-a6410c3681b541449845fc3f20fbc373.r2.dev/McElveen-KatzLiveSportsExample.mp4', label: 'McElveen Buick GMC – Katz Live Sports', type: 'video' },
  ],
};

const COMPLIANCE_STATEMENT = 'With submission of the above information, the dealer and/or dealer contact allows Martin Advertising to submit for the selected iMR sales amount to be debited from the dealership iMR portal. The funds will be used in GM compliant General Motors campaigns within the same calendar month of the submission. California and commercial campaigns not subject to sales match.';

const getOptionLabel = (options, id) => {
  const found = options.find(o => o.id === id);
  return found ? found.label : '';
};

const GMiMRPage = () => {
  useSeo({
    title: 'General Motors iMR Approval',
    description: 'General Motors dealer iMR approval form for Martin Advertising campaigns.',
    path: '/GMiMR',
    noIndex: true,
  });

  const [formData, setFormData] = useState({
    dealerName: '',
    dealerContact: '',
    bacCode: '',
    dealerEmail: '',
    complianceConsent: false
  });

  const [conquestOption, setConquestOption] = useState('');
  const [directMailOption, setDirectMailOption] = useState('');
  const [ottOption, setOttOption] = useState('');
  const [productionShootOption, setProductionShootOption] = useState('');
  const [tvRadioOption, setTvRadioOption] = useState('');
  const [submitStatus, setSubmitStatus] = useState('idle');
  const [creativeApproved, setCreativeApproved] = useState(false);
  const [activePanel, setActivePanel] = useState(null);
  const [lightboxAsset, setLightboxAsset] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleDirectSubmit = (e) => {
    e.preventDefault();
    handleSubmit();
  };

  const handleSubmit = async () => {
    if (!creativeApproved) {
      alert('Please review and approve the creative before submitting.');
      return;
    }

    setSubmitStatus('submitting');

    const data = new FormData();
    data.append('formName', 'GMiMRApproval');
    data.append('dealerName', formData.dealerName);
    data.append('dealerContact', formData.dealerContact);
    data.append('bacCode', formData.bacCode);
    data.append('dealerEmail', formData.dealerEmail);
    data.append('complianceConsent', String(formData.complianceConsent));
    data.append('complianceStatement', COMPLIANCE_STATEMENT);

    if (conquestOption) {
      data.append('conquestOptionId', conquestOption);
      data.append('conquestOptionLabel', getOptionLabel(CONQUEST_OPTIONS, conquestOption));
    }
    if (directMailOption) {
      data.append('directMailOptionId', directMailOption);
      data.append('directMailOptionLabel', getOptionLabel(DIRECT_MAIL_OPTIONS, directMailOption));
    }
    if (ottOption) {
      data.append('ottOptionId', ottOption);
      data.append('ottOptionLabel', getOptionLabel(OTT_OPTIONS, ottOption));
    }
    if (productionShootOption) {
      data.append('productionShootOptionId', productionShootOption);
      data.append('productionShootOptionLabel', getOptionLabel(PRODUCTION_SHOOT_OPTIONS, productionShootOption));
    }
    if (tvRadioOption) {
      data.append('tvRadioOptionId', tvRadioOption);
      data.append('tvRadioOptionLabel', getOptionLabel(TV_RADIO_OPTIONS, tvRadioOption));
    }

    try {
      const response = await fetch(IMR_EMAIL_ENDPOINT, {
        method: 'POST',
        body: data,
        mode: 'cors'
      });

      if (!response.ok) {
        throw new Error(`GM iMR submission failed with status ${response.status}`);
      }

      setSubmitStatus('submitted');
      setTimeout(() => {
        setFormData({
          dealerName: '',
          dealerContact: '',
          bacCode: '',
          dealerEmail: '',
          complianceConsent: false
        });
        setConquestOption('');
        setDirectMailOption('');
        setOttOption('');
        setProductionShootOption('');
        setTvRadioOption('');
        setCreativeApproved(false);
        setSubmitStatus('idle');
      }, 2000);
    } catch (error) {
      console.error('GM iMR form submission failed:', error);
      setSubmitStatus('failed');
      setTimeout(() => setSubmitStatus('idle'), 2500);
    }
  };

  const getButtonText = () => {
    switch (submitStatus) {
      case 'submitting': return 'Submitting...';
      case 'submitted': return 'Submitted!';
      case 'failed': return 'Submission Failed';
      default: return 'Submit';
    }
  };

  const togglePanel = (key) =>
    setActivePanel(prev => (prev === key ? null : key));

  const renderExampleLink = (sectionKey) => (
    <span
      className="imr-example-link"
      role="button"
      tabIndex={0}
      onClick={() => togglePanel(sectionKey)}
    >
      {' '}— CLICK FOR CREATIVE EXAMPLE
    </span>
  );

  const renderRadioSection = (label, options, value, onChange, sectionKey = null) => (
    <div className="imr-input-group">
      <label>
        {label}
        {sectionKey && renderExampleLink(sectionKey)}
      </label>
      <div className="imr-radio-options">
        {options.map((option) => (
          <div
            key={option.id}
            className={`imr-radio-option ${value === option.id ? 'selected' : ''}`}
            onClick={() => onChange(value === option.id ? '' : option.id)}
            role="radio"
            aria-checked={value === option.id}
            tabIndex={0}
            onKeyDown={(e) => (e.key === ' ' || e.key === 'Enter') && onChange(value === option.id ? '' : option.id)}
          >
            <input
              type="radio"
              name={`${label.replace(/\s+/g, '_')}_option`}
              value={option.id}
              checked={value === option.id}
              onChange={() => {}}
              tabIndex={-1}
            />
            <span>{option.label}</span>
          </div>
        ))}
      </div>
    </div>
  );

  const panelAssets = activePanel ? (SECTION_ASSETS[activePanel] || []) : [];

  return (
    <div className="imr-page">
      <div className="imr-overlay"></div>

      <div className="imr-form-container">
        <img src={martinLogo} alt="Martin Advertising" className="imr-logo" />
        <h1 className="imr-title">iMR Turnkey GM Approval Form</h1>
        <p className="imr-banner-copy">
          Martin Advertising will submit selected iMR funds for GM-compliant General Motors
          campaigns within the same calendar month.
        </p>

        <form onSubmit={handleDirectSubmit} className="imr-form">
          <div className="imr-input-row">
            <div className="imr-input-group">
              <label htmlFor="dealerName">Dealer Name</label>
              <input
                type="text"
                id="dealerName"
                name="dealerName"
                value={formData.dealerName}
                onChange={handleChange}
                required
                placeholder="Dealer Name"
              />
            </div>

            <div className="imr-input-group">
              <label htmlFor="dealerContact">Dealer Contact</label>
              <input
                type="text"
                id="dealerContact"
                name="dealerContact"
                value={formData.dealerContact}
                onChange={handleChange}
                required
                placeholder="First Last"
              />
            </div>
          </div>

          <div className="imr-input-group">
            <label htmlFor="bacCode">BAC Code</label>
            <input
              type="number"
              id="bacCode"
              name="bacCode"
              value={formData.bacCode}
              onChange={handleChange}
              required
              placeholder="Enter BAC code"
            />
          </div>

          <div className="imr-input-group">
            <label htmlFor="dealerEmail">Dealer Email</label>
            <input
              type="email"
              id="dealerEmail"
              name="dealerEmail"
              value={formData.dealerEmail}
              onChange={handleChange}
              required
              placeholder="Enter dealer email"
            />
          </div>

          {/* Section 1: OTT / Streaming */}
          {renderRadioSection('OTT / Streaming (Live Sports)', OTT_OPTIONS, ottOption, setOttOption, 'ott')}

          {/* Section 2: TV Spot Production */}
          {renderRadioSection('TV Spot Production', TV_RADIO_OPTIONS, tvRadioOption, setTvRadioOption, 'tvSpot')}

          {/* Section 3: Conquest Email */}
          {renderRadioSection('Conquest Email', CONQUEST_OPTIONS, conquestOption, setConquestOption, 'conquest')}

          {/* Section 4: Direct Mail */}
          {renderRadioSection('Direct Mail', DIRECT_MAIL_OPTIONS, directMailOption, setDirectMailOption, 'directMail')}

          {/* Section 5: On-Dealership Production Shoot */}
          {renderRadioSection('On-Dealership Production Shoot', PRODUCTION_SHOOT_OPTIONS, productionShootOption, setProductionShootOption, 'shoot')}

          <div className="imr-compliance">
            <label className="imr-compliance-checkbox" htmlFor="complianceConsent">
              <input
                type="checkbox"
                id="complianceConsent"
                name="complianceConsent"
                checked={formData.complianceConsent}
                onChange={handleChange}
                required
              />
              <span>{COMPLIANCE_STATEMENT}</span>
            </label>
          </div>

          <div className="imr-creative-approval">
            <label className="imr-compliance-checkbox">
              <input
                type="checkbox"
                checked={creativeApproved}
                onChange={e => setCreativeApproved(e.target.checked)}
              />
              <span>I have reviewed and approve the above selections for submission.</span>
            </label>
          </div>

          <button
            type="submit"
            className={`imr-submit-btn ${submitStatus}`}
            disabled={submitStatus !== 'idle'}
          >
            {getButtonText()}
          </button>
        </form>
      </div>

      {/* ── Slide-out creative panel ── */}
      {activePanel && (
        <div className="imr-slideout-backdrop" onClick={() => setActivePanel(null)} />
      )}
      <div className={`imr-slideout-panel ${activePanel ? 'open' : ''}`}>
        <div className="imr-slideout-header">
          <span className="imr-slideout-title">Creative Examples</span>
          <button className="imr-slideout-close" onClick={() => setActivePanel(null)}>✕</button>
        </div>
        <div className="imr-slideout-body">
          {panelAssets.length > 0 ? (
            panelAssets.map((asset, i) => (
              <div
                key={i}
                className="imr-slideout-card"
                onClick={() => setLightboxAsset(asset)}
              >
                {asset.type === 'image' ? (
                  <img src={asset.src} alt={asset.label} className="imr-slideout-thumb" />
                ) : asset.type === 'video' ? (
                  <div className="imr-slideout-video-thumb">
                    <video src={asset.src} className="imr-slideout-thumb" muted playsInline preload="metadata" />
                    <div className="imr-slideout-play-icon">▶</div>
                  </div>
                ) : (
                  <div className="imr-slideout-pdf">PDF</div>
                )}
                <span className="imr-slideout-label">{asset.label}</span>
              </div>
            ))
          ) : (
            <p className="imr-slideout-empty">Creative examples coming soon.</p>
          )}
        </div>
      </div>

      {/* ── Lightbox ── */}
      {lightboxAsset && (
        <div className="imr-lightbox-overlay" onClick={() => setLightboxAsset(null)}>
          <div className="imr-lightbox-content" onClick={e => e.stopPropagation()}>
            <button className="imr-lightbox-close" onClick={() => setLightboxAsset(null)}>✕</button>
            {lightboxAsset.type === 'image' ? (
              <img src={lightboxAsset.src} alt={lightboxAsset.label} className="imr-lightbox-img" />
            ) : lightboxAsset.type === 'video' ? (
              <video src={lightboxAsset.src} controls autoPlay className="imr-lightbox-video" />
            ) : (
              <iframe src={lightboxAsset.src} title={lightboxAsset.label} className="imr-lightbox-iframe" />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default GMiMRPage;
